import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { useDispatch, useSelector } from "react-redux";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import Datatable from "components/Datatables/datatable"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "helpers/api_helper"
import { MultiSelect } from "react-multi-select-component";

const isType = 'Last Month Same Day Orders'
const LMSD = () => {
    const [rowData, setRowData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [dropdownSelection, setDropdownSelection] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [filterData, setFilterData] = useState({
        'startdate': new Date(),
        'enddate': new Date(),
        'client': '',
        'type': 0
    });

    const getOptions = async() => {
        const res = await post(`/api/selectors/getclients`, {branch: "all"});
    
        if(res.status === 200) {
            setDropdownOptions(res.response)
        }
    }

    useEffect(getOptions,[])

    const submitCall = async() => {
        setRowData(null)
        setIsLoading(true)
        const { success, items } = await post(`api/reports/lmsd`, filterData);
        if(success){
            setRowData(items);
            const allDates = Object.keys(items[0].daily || {});
            const dateColumns = allDates.map((date, index) => ({
                dataField: `daily.${date}`,
                text: `${index+1} | % | Pro`,
                formatter: (cell, row) => {
                    const dayData = row.daily[date];
                    if (!dayData) return "-";

                    let symbol = "•"; // default dot
                    let colorStyle = { fontWeight: "bold", color: "gray" };

                    if (dayData.color === "green") {
                        symbol = "↑"; // up arrow
                        colorStyle.color = "green";
                    } else if (dayData.color === "red") {
                        symbol = "↓"; // down arrow
                        colorStyle.color = "red";
                    }

                    return (
                        <span style={colorStyle}>
                            {dayData.prev}/{dayData.curr} | {dayData.percent_change} | {symbol} 
                        </span>
                    );
                },
                csvFormatter: (cell, row) => {
                    const dayData = row.daily[date];
                    if (!dayData) return "-";

                    let symbol = "•"; // default dot
                    if (dayData.color === "green") symbol = "↑";
                    else if (dayData.color === "red") symbol = "↓";

                    // Return plain text for CSV
                    return `${dayData.prev}/${dayData.curr} | ${dayData.percent_change} | ${symbol}`;
                }
            }));
            setIsLoading(false)

            setTableColumns([
                { dataField: 'id', text: '#', formatter: (cell, row, rowIndex) => rowIndex + 1, csvFormatter: (cell, row, rowIndex) => rowIndex + 1 },
                { dataField: 'clientname', text: 'Client' },
                { dataField: 'client_code', text: 'Code' },
                { dataField: 'mobile', text: 'Mobile' },
                ...dateColumns
            ]);
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags> <title>Dashboard | {isType}</title> </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Reports" breadcrumbItem={isType} />
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={3} className={'mb-3'}>
                                            <label>Prev Month</label>
                                            <DatePicker showMonthYearPicker dateFormat="MM/yyyy" className="form-control" selected={filterData.startdate || new Date()} onChange={(date) => setFilterData(prev => ({...prev, startdate: date}))} />
                                        </Col>
                                        <Col md={3} className={'mb-3'}>
                                            <label>Compare Month</label>
                                            <DatePicker showMonthYearPicker dateFormat="MM/yyyy" className="form-control" minDate={filterData.startdate} selected={filterData.enddate || new Date()} onChange={(date) => setFilterData(prev => ({...prev, enddate: date}))} />
                                        </Col>
                                        <Col className={'mb-3'}>
                                            <label>Select Client</label>
                                            <MultiSelect
                                                options={dropdownOptions || []}
                                                value={dropdownSelection}
                                                onChange={(e) => {
                                                    if(e.length > 0){
                                                        setFilterData(prev => ({...prev, client: [...prev.client, e[0].value]}))
                                                    }else{
                                                        setFilterData(prev => ({...prev, client: e}))
                                                    }
                                                    setDropdownSelection(e)
                                                }}
                                                labelledBy="Select"
                                            />
                                        </Col>
                                        <Col md={1} style={{marginTop: '24px'}}>
                                            <button className="btn btn-primary float-end" onClick={() => submitCall()} disabled={isLoading} > Submit</button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    {
                                        tableColumns?.length > 0 && <Datatable
                                            keyField={'client_code'}
                                            title={`All ${isType}`}
                                            isAdd={false}
                                            is_remote={false}
                                            handleAddButton=''
                                            localSearch={true}
                                            columns={tableColumns}
                                            rowsLength={rowData?.length || 0}
                                            rows={rowData || []}
                                            loading={isLoading}
                                        />
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default LMSD
